import { Descriptions } from "element-ui";
import planApi from "../../../../api/planApi.js";
import StoreDBManger from "../../../../util/StoreDBManger.js";
import { gotoHomeList } from "../../../middle-ware/utils/ControlRouter.js";
import CameraUtil from "../../../../util/CameraUtil.js";
import WebCamJS from "@tibi/webcam";
import fa from "element-ui/src/locale/lang/fa.js";
import DateUtil from "../../../../util/DateUtil.js";
import { getTrainTypeTitle, imgBase64ToFile, loadSignOutValidUser } from "../util/trainDialogUtil.js";
import aliOssServe from "../../../../util/aliOssServe.js";
import QrCodeLogo from "../../../../components/vue-qrcode/QRCode.vue";
import { HudGlobal } from "../../../../util/HudGlobal.js";
import sys from "../../../../api/sys.js";
import GlobalHelper from "../../../../util/GlobalHelper.js";
import DeviceHelper from "../../../../util/helper/DeviceHelper.js";

// 确认强制签退页面
export default {
    name: "LoginForceOutSureDialog",
    props: {
        propDialogVisible: Boolean,
        propDialogObject: Object,
    },
    components: { QrCodeLogo },
    data() {
        const validateCheckNullKey = (rule, value, callback) => {
            if (value == "" || value == null) {
                return callback();
            } else {
                return callback();
            }
        };
        return {
            formObject: {
                operationDescription: "", // 说明
                taskType: 1, // 拍照方式
                taskPhoto: "",
                taskPhotoUrl: "",
                taskPhotoName: "",
            },
            dialogVisible: false, // 弹窗是否显示
            rules: {
                operationDescription: [{ required: true, message: "请输入说明", trigger: "blur" }, { validator: validateCheckNullKey }],
                taskPhotoUrl: [{ required: true, message: "请上传照片", trigger: "blur" }, { validator: validateCheckNullKey }],
            },
            // 摄像头配置
            webcamConfig: {
                width: 180,
                height: 220,
                dest_width: 180,
                dest_height: 220,
                crop_width: 180,
                crop_height: 220,
                image_format: "png",
                jpeg_quality: 100,
                force_flash: false,
                flip_horiz: true,
                fps: 60,
                upload_name: "webcam", // name of file in upload post data
                constraints: null, // custom user media constraints,
                swfURL: "webcam.swf", // URI to webcam.swf movie (defaults to the js location)
                flashNotDetectedText: "您的电脑没有检测到安装flash",
                noInterfaceFoundText: "没有检测到摄像头",
                unfreeze_snap: true, // Whether to unfreeze the camera after snap (defaults to true)
            },
            isTasking: true,
            isTaskLoading: false,
            taskResult: null,
            qrCodeContent: "", //
            // 二维码配置项
            opts: {
                errorCorrectionLevel: "H",
                type: "image/jpeg",
                rendererOpts: { quality: 0.8 },
                width: 160,
            },
            logoImg: require("@assets/logo.png"), // 二维码LOGO
            // 定时器
            timerObject: {
                // 检测定时器
                checkTimer: null,
                timerCount: 0,
                // 最大定时刷新时间 秒
                maxTimeCount: 60,
                isRequesting: false,
            },
            validUserInfo: {},
        };
    },
    watch: {
        propDialogVisible: {
            immediate: true,
            handler(value) {
                this.dialogVisible = value;
                if (value) {
                    this.$nextTick(() => {
                        this.isTasking = true;
                        this.isTaskLoading = false;
                        this.setupInitSearchForm();
                        this.initWithCamera("signUserTaskBox");
                        this.loadSignOutValidUser(); // 获取验证用户信息
                        this.loadQrImage();
                    });
                }
            },
        },
    },
    computed: {
        // 获取培训类型标题
        getTrainTypeTitle() {
            return getTrainTypeTitle(this.propDialogObject);
        },
        //
        iconImage() {
            console.log("iconImage", this.taskResult);
            if (this.taskResult && this.taskResult.pass === 1) {
                return require("@assets/img/force_out_sure_success.png");
            } else if (this.taskResult && this.taskResult.pass === 0) {
                return require("@assets/img/force_out_sure_error.png");
            } else {
                return require("@assets/img/force_out_sure_ing.png");
            }
        },
        iconText() {
            if (this.taskResult && this.taskResult.pass === 1) {
                return "验证通过";
            } else if (this.taskResult && this.taskResult.pass === 0) {
                return "验证失败";
            } else {
                return "还未验证";
            }
        },
        iconTextState() {
            if (this.taskResult) {
                return this.taskResult.pass;
            } else {
                return "2";
            }
        },
        /**
         *
         * @returns 确定按钮是否可以点击
         */
        isSureButtonDisDisable() {
            if (this.taskResult && this.taskResult.pass == 1) {
                return false;
            } else {
                return true;
            }
        },
        // 是否展示拍照按钮
        isShowTaskButton() {
            if (this.taskResult && this.taskResult.pass == 1) {
                return false;
            }
            return true;
        },
    },
    methods: {
        setupInitSearchForm() {
            this.formObject = {
                operationDescription: "", // 说明
                taskType: 1, // 拍照方式
                taskPhoto: "",
                taskPhotoUrl: "",
                taskPhotoName: "",
            };

            this.isTasking = true;
            this.isTaskLoading = false;
            this.taskResult = null;
            this.qrCodeContent = ""; //
            // 定时器
            this.timerObject = {
                // 检测定时器
                checkTimer: null,
                timerCount: 0,
                // 最大定时刷新时间 秒
                maxTimeCount: 60,
                isRequesting: false,
            };
            this.validUserInfo = {};
        },
        // ==========================event=========================
        // 重新拍照
        takeSignInPhoto() {
            if (this.isTasking) {
                this.isTaskLoading = true;
                this.loadTakeSignInPhoto();
            } else {
                // 重新拍照
                this.isTasking = true;
                this.formObject.taskPhotoUrl = "";
                this.formObject.taskPhotoName = "";
            }
        },
        // 拍照方式选择
        changeTaskType(value) {
            const that = this;
            this.isTaskLoading = false;
            this.taskResult = null; // 清空结果不能点击需要重新获取数据
            if (this.formObject.taskType == 2) {
                // 二维码
                this.$nextTick(() => {
                    that.$refs.qrSignCodeLogoBox && that.$refs.qrSignCodeLogoBox.toQrCode(that.qrCodeContent);
                });
                this.startCheckTimer(); // 开始定时器
            } else {
                this.stopCheckTimer(); // 停止定时器
                // 刷新结果
                this.getSignOutResult(true);

                const _this = this;
                setTimeout(function() {
                    _this.initWithCamera("signUserTaskBox");
                }, 100);
            }
        },
        /**
         * 关闭弹窗
         */
        closeDialog() {
            this.stopCheckTimer();
            this.$emit("update:propDialogVisible");
            this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
            this.$emit("close-dialog");
            // 关闭相机
            CameraUtil.closeCamera();
        },
        // 确认
        handleSure() {
            const that = this;
            this.$refs.ruleForm &&
                this.$refs.ruleForm.validate((valid, object) => {
                    if (valid) {
                        that.loadSignOutSure();
                    }
                });
        },
        /**
         * 确认强制签退
         */
        loadSignOutSure() {
            // 组装个对象回去
            const forceSignoutForm = {
                photoType: this.taskResult.photoType,
                photoName: this.taskResult.photoName,
                forceSignoutId: this.validUserInfo.forceSignoutId,
                offlineRecordId: this.validUserInfo.offlineRecordId,
                operationDescription: this.formObject.operationDescription,
                validFaceUrl: this.taskResult.validFaceUrl,
                validIdentityCode: this.validUserInfo.validIdentityCode,
                validIdentityName: this.validUserInfo.validIdentityName,
                validUserId: this.validUserInfo.validUserId,
                validUserRealName: this.validUserInfo.validUserRealName,
                operationUserId: this.$store.getters.userId,
                operationRealName: this.$store.getters.realName,
            };
            const backItem = this.propDialogObject;
            backItem.forceSignoutForm = forceSignoutForm;

            console.log("回传数据:", backItem);
            this.$emit("call-back", backItem); // 关闭弹窗
            this.closeDialog();
        },
        // ==========================data=========================
        // 刷新签退二维码生成数据
        // photoType photoName computer  电脑拍照. scan    扫码拍照
        generateQrData(data) {
            const qrCodeContent = {
                forceSignoutId: data.forceSignoutId,
                // offlineRecordId: data.offlineRecordId,
                // validIdentityCode: data.validIdentityCode,
                // validIdentityName: data.validIdentityName,
                // validUserId: data.validUserId,
                // validUserRealName: data.validUserRealName,
                // photoType: "scan",
                // photoName: "扫码拍照",
            };
            // Object.assign(qrCodeContent, data);

            this.qrCodeContent = JSON.stringify(qrCodeContent);
            console.log("二维码生成数据:", qrCodeContent);
        },
        // 获取需要验证人员的信息
        loadSignOutValidUser() {
            const that = this;
            loadSignOutValidUser(this.propDialogObject, (data, res) => {
                if (data) {
                    that.generateQrData(data);
                    // 赋值页面数据
                    that.validUserInfo = data;
                } else {
                    this.qrCodeContent = "";
                    this.handleNetWorkError(res);
                }
            });
        },
        /**
         * 获取参数数据
         */
        loadQrImage() {
            const that = this;
            const params = {
                parameterCodeList: "study_qrcode_logo",
                orgId: that.$store.getters.orgId,
            };
            sys.getParameterCodeAdminList(params).then((response) => {
                const { success, code, data, description } = response;
                if (success) {
                    if (data.study_qrcode_logo) {
                        const temp = JSON.parse(data.study_qrcode_logo);
                        GlobalHelper.getBase64Image(temp[0].parameterName, (dataURL) => {
                            that.logoImg = dataURL;
                        });
                    }
                }
            });
        },
        // ==========================拍照=========================
        /**
         *  初始化摄像头
         */
        initWithCamera(elementId, width, height) {
            // 1.检测校验是- 设置默认值
            if (elementId == null || elementId.length === 0) {
                console.warn("请设置相机组件的id");
                return;
            }
            if (!width || width === 0 || width == null) {
                width = 180;
            }
            if (!height || height === 0 || height == null) {
                height = 229;
            }
            this.webcamConfig.width = width;
            this.webcamConfig.height = height;
            this.webcamConfig.dest_width = width;
            this.webcamConfig.dest_height = height;
            // this.webcamConfig.crop_width = width;
            // this.webcamConfig.crop_height = height;

            // 开启之前先关闭
            CameraUtil.closeCamera();

            // 2. 基本配置
            WebCamJS.set(this.webcamConfig);

            // 3. 组件配置
            const elment = "#" + elementId;
            WebCamJS.attach(elment);

            // 修正摄像头显示
            let _this = this;
            WebCamJS.on("error", function(err) {
                console.log("摄像头错误", err);
                if (!WebCamJS.container) {
                    // that.initWithCamera(that.config.elementId, that.config.width, that.config.height);
                    _this.initWithCamera("signUserTaskBox");

                    // setTimeout(function() {
                    //     _this.takeSignInPhoto();
                    // }, 222);
                }
            });
        },
        // 拍照
        loadTakeSignInPhoto() {
            let _this = this;
            let fileName = DateUtil.dateFtt("yyyyMMddhhmmss", new Date());
            this.takeCameraSnapWithFileName(fileName)
                .then((res) => {
                    // 上传
                    let file = res.file;

                    // _this.signUserInfo.signInPhoto = res;

                    let storePath = "/user/force/out/" + _this.validUserInfo.validUserId + "/";

                    return aliOssServe.uploadVerifyPhoto(file, storePath);
                })
                .then((res) => {
                    // 上传结果处理
                    console.log("上传结果", res);

                    // 显示出来
                    _this.isTaskLoading = false; // 拍照完成
                    _this.isTasking = false; // 拍照完成

                    _this.$nextTick(() => {
                        _this.formObject.taskPhotoUrl = res.url;
                        _this.formObject.taskPhotoName = res.name;
                        console.log("图片地址", _this.formObject.taskPhotoUrl);
                        // 提交拍照数据
                        _this.submitTaskData();
                    });
                });
        },
        /**
         * 开始拍照并返回
         */
        takeCameraSnapWithFileName(fileName) {
            return new Promise((resolve, reject) => {
                const that = this;
                WebCamJS.snap(function(data_base64, cavas, context) {
                    //返回data
                    imgBase64ToFile(data_base64, fileName || "file").then((file) => {
                        const item = {
                            base64: data_base64,
                            file: file,
                        };
                        if (resolve) {
                            resolve(item);
                        }
                    });
                });
            });
        },
        // 提交拍照数据
        submitTaskData() {
            const that = this;
            const params = {
                photoType: "computer",
                photoName: "电脑拍照",
                forceSignoutId: that.validUserInfo.forceSignoutId,
                offlineRecordId: that.validUserInfo.offlineRecordId,
                validFaceUrl: that.formObject.taskPhotoName,
                validIdentityCode: that.validUserInfo.validIdentityCode,
                validIdentityName: that.validUserInfo.validIdentityName,
                validUserId: that.validUserInfo.validUserId,
                validUserRealName: that.validUserInfo.validUserRealName,
                sourceType: 15,
            };
            Object.assign(params, this.validUserInfo);
            planApi.postSignOutValid(params).then((response) => {
                const { success, data } = response;
                // 查询结果
                that.getSignOutResult(true);
                if (success) {
                    // 查询结果
                    // that.getSignOutResult(true);
                } else {
                    that.handleNetWorkError(response);
                }
            });
        },
        // ==========================计时器=========================
        /**
         * 开启定时器
         */
        startCheckTimer() {
            const that = this;
            this.stopCheckTimer();
            that.timerObject.timeCount = 0;
            this.timerObject.checkTimer = setInterval(() => {
                that.timerObject.timeCount = that.timerObject.timeCount + 1;

                if (!that.timerObject.isRequesting) {
                    // 如果正在请求则先不执行
                    that.handleTimerQueryStateEvent();
                }
            }, 1500);
        },
        /**
         * 关闭计时器
         */
        stopCheckTimer() {
            clearInterval(this.timerObject.checkTimer);
            this.timerObject.checkTimer = null;
            console.log("定时器已停止", this.timerObject);
        },
        /**
         * 定时任务
         */
        handleTimerQueryStateEvent() {
            this.getSignOutResult();
        },
        /**
         * 查询拍照方式上传图片之后的结果
         */
        getSignOutResult(isComputer) {
            this.timerObject.isRequesting = true; // 请求中
            const that = this;
            const params = {
                ipAddr: DeviceHelper.getIpAddress(),
            };
            Object.assign(params, this.validUserInfo);
            if (isComputer) {
                params.photoName = "电脑拍照";
                params.photoType = "computer";
            } else {
                params.photoName = "扫码拍照";
                params.photoType = "scan";
            }
            planApi.getSignOutTaskResult(params).then((response) => {
                const { success, data, code } = response;
                if (success && data) {
                    if (data.pass == 0) {
                        // 验证失败
                        that.taskResult = response.data;
                        that.isTasking = true;
                        that.timerObject.isRequesting = false;
                    } else {
                        that.taskResult = response.data;
                        that.formObject.taskPhotoUrl = response.data.prefixValidFaceUrl; // 全路径
                        that.isTasking = false;
                        that.timerObject.isRequesting = false;

                        if (!isComputer) {
                            // 获取到通过的数据停止循环查询
                            this.stopCheckTimer();
                        } else {
                            // 如果是电脑拍照成功就关闭相机
                            CameraUtil.closeCamera();
                        }
                    }
                } else {
                    // 失败
                    that.taskResult = null;
                    that.isTasking = true;
                    that.timerObject.isRequesting = false;
                    that.formObject.taskPhotoUrl = "";

                    if (!isComputer) {
                        // 获取不到数据继续查询
                        // this.handleTimerQueryStateEvent();
                    }
                    this.handleNetWorkError(response, false);
                }
            });
        },
        // 处理失败提示
        handleNetWorkError(res, isShowAlert = true) {
            const that = this;

            if (res.code == 80701) {
                // 获取到通过的数据停止循环查询
                this.stopCheckTimer();
                HudGlobal.showUniversalAlert(res.description).then(() => {
                    that.$emit("call-back"); // 关闭弹窗
                    that.closeDialog();
                });
                return;
            } else {
                if (isShowAlert) {
                    HudGlobal.showErrorWithMessage(res.description);
                }
            }
        },
    },
};
